/**
 * 多边动态-用户端接口
 */
import { pbrAxios } from '../../common/js/pbrAxios'

/** 列表搜索 */
const searchMultilateralDynamics = (body, query = {}) =>
  pbrAxios.post('/front/multilateralDynamics/search', body, { params: query })

/** 区域预览 */
const fetchMultilateralRegionStatistic = (body, query = {}) =>
  pbrAxios.post('/front/multilateralDynamics/regionStatistic', body, { params: query })

/** 导出 */
const exportMultilateralDynamicsExcelUrl = '/front/multilateralDynamics/exportExcel'
const exportMultilateralDetailWordUrl = '/front/multilateralDynamics/exportDetailWord'

/** 保存搜索历史 */
const saveMultilateralSearchHistory = params =>
  pbrAxios.post('/front/multilateralDynamics/saveSearchHistory', params)

/** 获取搜索历史 */
const fetchMultilateralSearchHistory = params =>
  pbrAxios.post('/front/multilateralDynamics/ghconditions', params)

/** 搜索历史置顶 */
const pinMultilateralSearchHistory = params =>
  pbrAxios.post('/front/multilateralDynamics/upconditions', params)

/** 删除单条搜索历史 */
const deleteMultilateralSearchHistory = params =>
  pbrAxios.post('/front/multilateralDynamics/dhconditions', params)

/** 删除全部搜索历史 */
const deleteAllMultilateralSearchHistory = params =>
  pbrAxios.post('/front/multilateralDynamics/delAllHistory', params)

/** 详情 */
const fetchMultilateralDynamicsDetail = params =>
  pbrAxios.post('/front/multilateralDynamics/detail', params)

/**
 * 按代码表获取字典项
 * @param {String} dictCode mld_tag | mld_category | mld_region | mld_org
 */
const fetchMultilateralDictItems = dictCode =>
  pbrAxios.get('/front/multilateralDynamics/getDictItems', { params: { dictCode } })

export default {
  searchMultilateralDynamics,
  fetchMultilateralRegionStatistic,
  exportMultilateralDynamicsExcelUrl,
  exportMultilateralDetailWordUrl,
  saveMultilateralSearchHistory,
  fetchMultilateralSearchHistory,
  pinMultilateralSearchHistory,
  deleteMultilateralSearchHistory,
  deleteAllMultilateralSearchHistory,
  fetchMultilateralDynamicsDetail,
  fetchMultilateralDictItems
}
